module.exports = __webpack_public_path__ + "media/images/emblems/Vuiteboeuf-coat_of_arms-5a00554156aab219aa19550ad3be0bce.svg";